"use client"
import { type ReactNode, createContext, use, useState } from "react"

type AuthorHoverContextType = {
  readonly hoveredAuthorIndex: number | null
  readonly handleMouseEnter: (index: number) => void
  readonly handleMouseLeave: () => void
}

const AuthorHoverContext = createContext<AuthorHoverContextType | undefined>(
  undefined,
)

export function useAuthorHover() {
  const context = use(AuthorHoverContext)
  if (context === undefined) {
    throw new Error("useAuthorHover must be used within an AuthorHoverProvider")
  }
  return context
}

type AuthorHoverProviderProps = {
  readonly children: ReactNode
}

export function AuthorHoverProvider({ children }: AuthorHoverProviderProps) {
  const [hoveredAuthorIndex, setHoveredAuthorIndex] = useState<number | null>(
    null,
  )

  const handleMouseEnter = (index: number) => {
    setHoveredAuthorIndex(index)
  }

  const handleMouseLeave = () => {
    setHoveredAuthorIndex(null)
  }

  const value: AuthorHoverContextType = {
    handleMouseEnter,
    handleMouseLeave,
    hoveredAuthorIndex,
  }

  return <AuthorHoverContext value={value}>{children}</AuthorHoverContext>
}
